import { UntypedFormControl } from "@angular/forms";
import { isEmpty } from "lodash";

export class FormValidators {
	static EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

	static PW_NUM = /\d/;
	static PW_UC = /[A-Z]/;
	static PW_LC = /[a-z]/;
	static PW_SC = /[^0-9a-zA-Z]/;

	static ENTITY_REGEX = /d(\d+)c(\d+)r(\d+)/;
	static TEMPLATE_REGEX = /d(\d+)c(\d+)t(\d+)/;

	public static validEmail(c: UntypedFormControl): { [key: string]: boolean } {
		if (c.value && !FormValidators.EMAIL_REGEXP.test(c.value)) {
			return { "invalidEmail": true };
		}
	}

	public static validPassword(c: UntypedFormControl): { [key: string]: boolean } {
		const output: { [key: string]: boolean } = {};

		if (c.value) {
			const value = <string>c.value;
			if (value.length < 8) {
				output["invalidPasswordLength"] = true;
			}
			if (!FormValidators.PW_NUM.test(value)) {
				output["invalidPasswordNumber"] = true;
			}
			if (!FormValidators.PW_UC.test(value)) {
				output["invalidPasswordUpperCase"] = true;
			}
			if (!FormValidators.PW_LC.test(value)) {
				output["invalidPasswordLowerCase"] = true;
			}
			if (!FormValidators.PW_SC.test(value)) {
				output["invalidPasswordSpecialCharacter"] = true;
			}
		}

		if (!isEmpty(output)) {
			output["invalidPassword"] = true;

			return output;
		}

		return null;
	}

	public static validEntityID(c: UntypedFormControl): { [key: string]: boolean } {
		if (c.value && !FormValidators.ENTITY_REGEX.test(c.value)) {
			return { "invalidEntityID": true };
		}
		return null;
	}

	public static validTemplateID(c: UntypedFormControl): { [key: string]: boolean } {
		if (c.value && !FormValidators.TEMPLATE_REGEX.test(c.value)) {
			return { "invalidTemplateID": true };
		}
		return null;
	}

	public static validEntityIDOrTemplateID(c: UntypedFormControl): { [key: string]: boolean } {
		if (c.value && !FormValidators.ENTITY_REGEX.test(c.value) && !FormValidators.TEMPLATE_REGEX.test(c.value)) {
			return { "invalidEntityOrTemplateID": true };
		}
		return null;
	}

	public static confirmPasswordsMatch(c: UntypedFormControl): { [key: string]: boolean } {
		if (c.get("password").value !== c.get("confirmPassword").value) {
			return { "passwordMismatch": true };
		}
		return null;
	}
}
